import React from 'react'
import './style.css'

const CardInfoPure = (props) => {
  const { image, alt, title, content } = props

  return (
    <div className='card-info'>
      <img src={image} alt={alt || 'description'} className='card-info-image' />
      <div className='card-info-content'>
        <h3>{title}</h3>
        <p className='card-info-content-p'>{content}</p>
      </div>
    </div>
  )
}

export default CardInfoPure
